import React from 'react';
import { services } from '../mockData';
import { Briefcase, FileText, Scale, Globe, TrendingUp } from 'lucide-react';

const Services = () => {
  const icons = [<Briefcase size={40} />, <FileText size={40} />, <Scale size={40} />, <Globe size={40} />, <TrendingUp size={40} />];

  return (
    <section id="services" className="section-dark">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-2">NUESTROS SERVICIOS</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle body-medium">
            Ofrecemos un servicio integral y personalizado para impulsar la carrera profesional de nuestros representados.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={service.id} className="service-card">
              <div className="service-icon">{icons[index]}</div>
              <h3 className="heading-5">{service.title}</h3>
              <p className="body-small">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;